import {Component, EventEmitter} from '@angular/core';
import { HomeService } from '../home.service';
import { HomeGraphData } from '../home.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'iaud-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent {
  homeGraphData$: Observable<HomeGraphData>;
  refreshToken$ = new BehaviorSubject(undefined);
  reloadEvent = new EventEmitter<boolean>();

  constructor(private homeService: HomeService) {
    this.homeGraphData$ = this.refreshToken$.pipe(
      switchMap(() => this.homeService.getHomeGraphData())
    );

    this.reloadEvent.subscribe(() => this.refresh());
  }

  refresh(): void {
    this.refreshToken$.next(undefined);
  }
}
